import { PropsWithChildren } from "react";

import { cn } from "@/lib/cn";
import { Row, type RowData } from "@tanstack/react-table";

interface DatatableCellTitleProps<TData extends RowData> extends PropsWithChildren {
  row: Row<TData>;
  className?: string;
}

export const DatatableCellTitle = <TData extends RowData>({ children, className }: DatatableCellTitleProps<TData>) => {
  return (
    <div className={cn("flex h-full min-w-[10rem] max-w-full flex-1 items-center overflow-hidden px-2", className)}>
      {children}
    </div>
  );
};
